import React from 'react';
import { useWatch } from 'react-hook-form';
import {
    CREDIT_NOTE_AMOUNT,
    IOrderSale,
    REQUIRE_CREDIT_NOTE,
} from '../../order-sale-form';
import { RhNumberField } from '../../../../../../../dum';
import { useReceiptAppliesTax } from '../../helpers/use-receipt-applies-tax';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function CreditNoteAmountInput() {
    const requireCreditNote = useWatch({
        name: REQUIRE_CREDIT_NOTE,
    }) as IOrderSale['require_credit_note'];
    const appliesTax = useReceiptAppliesTax();

    return (
        <RhNumberField
            disabled={!requireCreditNote || !appliesTax}
            name={CREDIT_NOTE_AMOUNT}
            label={shortLabel(FIELD_LABELS.credit_note_amount)}
        />
    );
}
